import {
    Card,
    Table,
    Tag,
    Space,
    Input,
    Button,
    Popconfirm,
    message,
    Popover,
} from 'antd'
import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { getProjectList, delProject } from '../../server/http'
import { img_url } from '../../config/mosycle'
import ProjectDrawer from '../../components/ProjectDrawer'
const { Search } = Input

function ProductList() {
    let searchInput = () => (
        <Search
            placeholder="input search text"
            enterButton="Search"
            size="small"
        />
    )

    const [list, setList] = React.useState([])
    const [page, setPage] = React.useState(1)
    const [pageSize, setPageSize] = React.useState(10)
    const [total, setTotal] = React.useState(0)

    const [temp, setTemp] = React.useState('')
    // const [productCode, setProductCode] = React.useState('')
    const [name, setName] = React.useState('')

    const [showDrawer, setShowDrawer] = React.useState(false)
    const [formData, setFormData] = React.useState({})
    const [visible, setVisible] = React.useState(false)
    React.useEffect(() => {
        let params = {
            page,
            // pageSize,
            // tab: 'buys',
            // status,
            name,
            // username,
        }
        getData(params)
    }, [page, name])
    function getData(params) {
        getProjectList(params).then((res) => {
            setList(res.data.data)
            setTotal(res.data.total)
        })
    }
    const onClose = () => {
        setVisible(false)
        setShowDrawer(false)
        setFormData({})
    }
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node
                    }}
                    placeholder={dataIndex === 'name' ? '输入工程名字' : ''}
                    value={selectedKeys[0]}
                    onChange={(e) => {
                        setTemp(e.target.value ? e.target.value : '')
                    }}
                    onPressEnter={(e) => {
                        setName(e.target.value ? e.target.value : '')
                    }}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => {
                            setName(temp)
                        }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        搜索
                    </Button>
                    <Button
                        onClick={() => {
                            setName(temp)

                            setTemp('')
                            clearFilters()
                            console.log(clearFilters)
                        }}
                        size="small"
                        style={{ width: 90 }}
                    >
                        重置
                    </Button>
                </Space>
            </div>
        ),

        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100)
            }
        },
    })
    const columns = [
        {
            title: '展示图',
            dataIndex: 'thumb',
            key: 'thumb',
            render: (thumb) => (
                <a href={img_url + thumb} target="_blank" rel="noreferrer">
                    <img
                        src={img_url + thumb}
                        style={{ width: '30px' }}
                        alt=""
                    />
                </a>
            ),
        },

        {
            title: '分类',
            dataIndex: 'category',
            key: 'category',
            render: (category) => <Tag color="green">{category}</Tag>,
        },
        {
            title: '标题',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name'),
        },
        {
            title: '关联产品编号',
            dataIndex: 'products',
            key: 'products',
            render: (products) => <Tag color="blue">{products}</Tag>,
        },
        {
            title: '首页显示',
            dataIndex: 'show_index',
            key: 'show_index',
            render: (show_index) => (
                <Tag color={show_index === 0 ? 'default' : 'blue'}>
                    {show_index === 0 ? '否' : '是'}
                </Tag>
            ),
        },
        {
            title: '描述',
            dataIndex: 'desc',
            key: 'desc',
            render: (desc) => (
                <Popover content={desc}>
                    <Button type="text">{desc.slice(0, 15)}...</Button>
                </Popover>
            ),
        },

        {
            title: '操作',
            key: 'action',
            dataIndex: 'id',
            render: (text, record) => (
                <Space size="middle">
                    <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                            // console.log(record)
                            setShowDrawer(true)
                            let params = record
                            // params['usage'] = params['usage'].split(',')
                            setFormData(params)
                            setVisible(true)
                        }}
                    >
                        编辑
                    </Button>

                    <Popconfirm
                        title="确定要删除该数据吗?"
                        onConfirm={(e) => {
                            // console.log(text)

                            delProject({ id: text }).then((res) => {
                                message.success(res.message)
                                getData()
                            })
                        }}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="danger" size="small">
                            删除
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ]

    return (
        <Card title="产品列表">
            <Table
                columns={columns}
                dataSource={list}
                rowKey="id"
                pagination={{
                    pageSize,
                    total,
                    // showSizeChanger: true,
                    // pageSizeOptions: ['8', '10', '20', '30'],
                    onChange: (page, pageSize) => {
                        setPage(page)
                        setPageSize(pageSize)
                    },
                }}
            />

            {showDrawer ? (
                <ProjectDrawer
                    onClose={onClose}
                    formData={formData}
                    visible={visible}
                    setShowDrawer={setShowDrawer}
                    getData={getData}
                    setFormData={setFormData}
                />
            ) : (
                ''
            )}
        </Card>
    )
}

export default ProductList
